var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section-title", { staticClass: "mt-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.applicantName) +
            ",\n    " +
            _vm._s(
              _vm.$t(
                "application-standalone.pages.identifications.tellUsAboutThisIdentification"
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.identificationTypeVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.questions.identifications.type"
                                )
                              ) +
                              "\n          "
                          ),
                          _vm.getValidator("identificationType.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("select-field", {
                        attrs: {
                          value: _vm.identificationType,
                          placeholder: _vm.$t(
                            "application-form.identification-type"
                          ),
                          options: _vm.applicantIdentificationOptions,
                          validator: _vm.getValidator("identificationType"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.identificationType = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.identificationCountryVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.questions.identifications.country"
                                )
                              ) +
                              "\n          "
                          ),
                          _vm.getValidator("identificationCountry.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("text-field", {
                        attrs: {
                          value: _vm.identificationCountry,
                          placeholder: _vm.$t("application-form.country"),
                          validator: _vm.getValidator("identificationCountry"),
                          "max-length": 30,
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.identificationCountry = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.identificationNumberVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.questions.identifications.number"
                                )
                              ) +
                              "\n          "
                          ),
                          _vm.getValidator("identificationNumber.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("text-field", {
                        attrs: {
                          value: _vm.identificationNumber,
                          placeholder: _vm.$t("application-form.id-number"),
                          validator: _vm.getValidator("identificationNumber"),
                          "max-length": 30,
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.identificationNumber = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }